const initialState = { ids: [], entities: {} };
export default function reducer(state = initialState /* , action */) {
  return state;
}

export const selectors = {
  getRoleEntities(state) {
    return state.roles.entities;
  }
};
